module.exports = __webpack_public_path__ + "static/img/batb.d0289dc0.png";